var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "room-completed",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 252,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 6.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a2e92a",
    floodOpacity: 0.77
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a2e92a",
    floodOpacity: 0.77
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 149.51,
    y1: 42.6,
    x2: 154.69,
    y2: 124.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1c2538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1d2637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#212d37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#2a3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#354a35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#446033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#577b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6d9c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#86c02c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 6.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a2e92a",
    floodOpacity: 0.77
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 6.98
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a2e92a",
    floodOpacity: 0.77
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 188.33,
    y1: 39.76,
    x2: 187.1,
    y2: 118.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#223654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#233753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#283e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#304a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3c5b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4c7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#608c3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#77ac38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#91d12f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a3ea2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 104.41,
    y1: 129.26,
    x2: 100.97,
    y2: 213.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 148.64,
    y1: 109.09,
    x2: 143.91,
    y2: 219.21,
    xlinkHref: "#linear-gradient-2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "133.1 52.04 171.02 52.04 203.75 48.47 171.02 39.35 133.1 52.04",
    style: {
      fill: "#a2e92a",
      filter: "url(#outer-glow-1)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.28 131.46 127.84 118.22 166.45 130.42 126.23 137.47 82.28 131.46",
    style: {
      fill: "#a2e92a",
      filter: "url(#outer-glow-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.54 101.65 169.55 103.02 204.73 98.76 171.49 95.6 131.54 101.65",
    style: {
      fill: "#a2e92a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.1 52.04 131.54 101.65 171.49 95.6 171.02 39.35 133.1 52.04",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.45 123.53 133.82 123.6 133.62 124.32 124.79 124.19 124.45 123.53",
    style: {
      fill: "#fff",
      filter: "url(#outer-glow-3)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.86 122.17 134.24 122.17 133.82 123.6 124.45 123.53 124.86 122.17",
    style: {
      fill: "#fff",
      filter: "url(#outer-glow-4)",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".05px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "144.48 148.14 157.08 42.55 158.19 42.37 145.77 147.93 144.48 148.14",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.19 42.37 158.49 44.16 146.17 148.82 145.77 147.93 158.19 42.37",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.95 148.45 147.54 45.38 148.65 45.19 135.24 148.23 133.95 148.45",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.65 45.19 148.95 46.99 135.64 149.13 135.24 148.23 148.65 45.19",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.58 122.57 147.71 121.06 147.89 119.61 138.77 121.12 138.58 122.57",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.97 123.24 147.62 121.81 147.71 121.06 138.58 122.57 138.97 123.24",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.99 111.75 149 110.26 149.17 108.83 140.17 110.32 139.99 111.75",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.93 110.9 140.44 112.3 139.99 111.75 149 110.26 148.93 110.9",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.49 100.21 150.38 98.74 150.55 97.33 141.67 98.8 141.49 100.21",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.95 100.73 150.31 99.35 150.38 98.74 141.49 100.21 141.95 100.73",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.01 88.56 151.77 87.11 151.93 85.71 143.19 87.16 143.01 88.56",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.45 89.22 151.68 87.86 151.77 87.11 143.01 88.56 143.45 89.22",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.41 77.75 153.05 76.32 153.24 74.79 144.61 76.22 144.41 77.75",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.97 77.01 144.86 78.35 144.41 77.75 153.05 76.32 152.97 77.01",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.82 66.96 154.34 65.55 154.52 64.03 146.02 65.44 145.82 66.96",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.27 67.57 154.26 66.25 154.34 65.55 145.82 66.96 146.27 67.57",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.24 56.05 155.64 54.66 155.8 53.28 147.42 54.67 147.24 56.05",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.69 56.67 155.56 55.36 155.64 54.66 147.24 56.05 147.69 56.67",
    style: {
      fill: "#333d4c"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "171.02 39.35 203.75 48.47 204.73 98.76 171.49 95.6 171.02 39.35",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.1 190.45 123.29 193.87 165.37 190.45 125.95 185.13 78.1 190.45",
    style: {
      fill: "#a2e92a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.28 131.46 78.1 190.45 125.95 185.13 128.03 118.13 82.28 131.46",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.84 118.22 166.45 130.42 165.56 190.35 125.2 185.24 127.84 118.22",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "93.66 244.99 110.86 119.53 112.29 119.32 95.32 244.74 93.66 244.99",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.29 119.32 112.63 121.63 95.82 245.9 95.32 244.74 112.29 119.32",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.12 245.17 98.54 122.96 99.97 122.75 81.78 244.92 80.12 245.17",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.97 122.75 100.32 125.06 82.28 246.07 81.78 244.92 99.97 122.75",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.13 237.69 95.06 236 94.93 236.95 83.68 238.47 83.13 237.69",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.39 235.89 95.31 234.11 95.06 236 83.13 237.69 83.39 235.89",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.44 221.92 97.2 220.17 97.45 218.31 85.71 220.06 85.44 221.92",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.93 222.79 97.07 221.13 97.2 220.17 85.44 221.92 85.93 222.79",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.47 208.05 99.08 206.32 99.33 204.5 87.74 206.22 87.47 208.05",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.97 207.14 88.04 208.77 87.47 208.05 99.08 206.32 98.97 207.14",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.64 193.26 101.09 191.55 101.33 189.75 89.9 191.46 89.64 193.26",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.21 193.94 100.98 192.33 101.09 191.55 89.64 193.26 90.21 193.94",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.83 178.33 103.11 176.65 103.35 174.86 92.09 176.54 91.83 178.33",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.38 179.19 102.98 177.61 103.11 176.65 91.83 178.33 92.38 179.19",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.86 164.47 104.98 162.81 105.25 160.86 94.14 162.52 93.86 164.47",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.86 163.7 94.42 165.26 93.86 164.47 104.98 162.81 104.86 163.7",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.88 150.64 106.86 149.01 107.12 147.07 96.17 148.7 95.88 150.64",
    style: {
      fill: "#727c92"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.45 151.44 106.74 149.91 106.86 149.01 95.88 150.64 96.45 151.44",
    style: {
      fill: "#333d4c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.93 136.66 108.75 135.05 108.99 133.29 98.19 134.9 97.93 136.66",
    style: {
      fill: "#727c92",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".06px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.5 137.47 108.63 135.96 108.75 135.05 97.93 136.66 98.5 137.47",
    style: {
      fill: "#333d4c",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: ".06px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.28 246.07 80.6 246.32 80.12 245.17 81.78 244.92 82.28 246.07",
    style: {
      fill: "#a2e92a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.82 245.9 94.24 246.13 93.66 244.99 95.32 244.74 95.82 245.9",
    style: {
      fill: "#a2e92a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cloud cloud-1",
    id: "Artwork_153",
    "data-name": "Artwork 153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m263.42,170h-116.83c-.27,0-.51-.22-.49-.51.25-5.79,4.72-10.4,10.19-10.4,1.87,0,3.63.54,5.13,1.48.46.29,1.07.06,1.25-.47,1.06-3.28,3.97-5.65,7.4-5.65.6,0,1.19.07,1.75.21.56.14,1.11-.35,1.02-.93-.12-.89-.19-1.81-.19-2.74,0-10.5,7.96-19.01,17.77-19.01,8.36,0,15.36,6.17,17.27,14.49.07.33.33.59.67.66,1.13.21,2.14.78,2.93,1.59.25.26.64.34.95.19,1.99-.92,4.18-1.44,6.47-1.44,6.34,0,11.84,3.9,14.51,9.58.15.33.49.52.86.49.11-.01.2-.01.31-.01,1.65,0,3.1.86,4,2.18.21.32.59.46.95.35,2.19-.62,4.61-.98,7.18-.98,9.3,0,16.9,4.59,17.35,10.37.05.28-.18.54-.47.54Z",
    style: {
      fill: "#d4d8df"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "cloud cloud-2",
    id: "Artwork_153-2",
    "data-name": "Artwork 153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.61,76H36.4c-.17,0-.31-.14-.31-.31.15-3.58,2.92-6.43,6.3-6.43,1.16,0,2.24.33,3.17.92.28.18.66.04.77-.29.65-2.03,2.45-3.49,4.58-3.49.37,0,.73.04,1.08.13.35.09.68-.22.63-.57-.07-.55-.12-1.12-.12-1.69,0-6.49,4.92-11.75,10.98-11.75,5.16,0,9.49,3.81,10.67,8.95.04.2.2.36.41.41.7.13,1.32.48,1.81.98.15.16.39.21.59.12,1.23-.57,2.58-.89,4-.89,3.92,0,7.32,2.41,8.97,5.92.09.2.31.32.53.31.07,0,.12,0,.19,0,1.02,0,1.91.53,2.47,1.35.13.2.36.28.59.22,1.35-.39,2.85-.6,4.44-.6,5.75,0,10.45,2.84,10.72,6.41.03.17-.11.33-.29.33Z",
    style: {
      fill: "#d4d8df"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171.9,
    y: 21,
    width: 2,
    height: 24,
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.78,21.14v8.52s3.53-1.89,9.72-1.01,8.4,2.21,8.4,2.21v-9.72s-4.86,1.55-9.06.77-8.94-.91-8.94-.91",
    style: {
      fill: "#a3ea2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomCompleted);
export default __webpack_public_path__ + "static/media/room-completed.c05b93d4bf16f26cd0e9b65e0c18e451.svg";
export { ForwardRef as ReactComponent };